<template>
    <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-lg">

                    <h3>{{ title }}</h3>
                </div>
                <div class="col-lg-auto">
                    <button class="btn btn-outline-secondary"
                            v-on:click="addAdditionalItem()"
                            type="button">{{ $t('general.add') }}
                    </button>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="form-group  ">

                <div v-for="(newField,index) in newAdditionalFields">
                    <div class="row">

                        <div class="col-lg">
                            <label class="w-100">
                                {{ $t('additional_field.name') }}
                                <input type="text"
                                       class="form-control"
                                       @change="emitChange"
                                       required
                                       v-model="newField.name"/>

                            </label>

                        </div>
                        <div class="col-lg-2">
                            <label class="w-100">
                                {{ $t('general.hint') }}
                                <input type="text"
                                       class="form-control"
                                       @change="emitChange"

                                       v-model="newField.placeholder"/>

                            </label>

                        </div>

                        <div class="col-lg-2">
                            <label class="w-100">
                                {{ $t('general.type') }}
                                <select v-model="newField.type"
                                        class="form-control">
                                    <option value="text">{{ $t('general.text') }}</option>
                                    <option value="number">{{ $t('general.number') }}</option>
                                </select>
                            </label>
                        </div>
                        <div class="col-lg-2">
                            <label class="">
                                {{ $t('general.required_q') }}
                                <input type="checkbox"
                                       class="form-control"
                                       @change="emitChange"
                                       v-model="newField.required"/>

                            </label>
                        </div>

                        <div class="col-lg-auto pt-4">
                            <button type="button"
                                    @click="removeAdditionalField(newField)"
                                    class="btn btn-sm btn-outline-danger">{{ $t('general.remove') }}
                            </button>

                        </div>

                    </div>
                    <hr>
                </div>
            </div>
        </div>
        <input type="hidden"
               name="additional_fields"
               v-bind:value="JSON.stringify(newAdditionalFields)">
    </div>
</template>

<script>

import {ref, watch} from 'vue';
import {snakeCase} from "lodash";

export default {
    name: 'DocumentTypesAdditionalFields',
    props: {
        title: {
            type: String,
            default: ''
        },
        additionalFields: {
            type: Array,
            required: true
        },
    },
    setup(props, {emit}) {
        console.log('additionalFields prop:', props.additionalFields, typeof props.additionalFields);

        // Upewnij się że props.additionalFields jest tablicą
        const initialFields = Array.isArray(props.additionalFields)
            ? props.additionalFields
            : [];

        const newAdditionalFields = ref(initialFields);

        const myChangeEvent = (newField, val) => {
            newField.additional_field_id = val;
        };

        const addAdditionalItem = () => {
            newAdditionalFields.value.push({
                name: '',
                placeholder: '',
                type: 'text',
                required: true
            });
            emitChange();
        };

        const removeAdditionalField = (field) => {
            const index = newAdditionalFields.value.indexOf(field);
            if (index > -1) {
                newAdditionalFields.value.splice(index, 1);
            }
            console.log(newAdditionalFields.value);
            emitChange();
        };

        const emitChange = () => {
            emit('fieldsChanged', newAdditionalFields.value);
        };
        // Watch for changes in the `name` field and generate a slug
        watch(
            newAdditionalFields,
            (fields) => {
                fields.forEach((field) => {
                    if (field.name) {
                        field.slug = snakeCase(field.name);
                    }
                });
            },
            {deep: true}
        );

        return {
            newAdditionalFields,
            myChangeEvent,
            addAdditionalItem,
            removeAdditionalField,
            emitChange
        };
    }
}
</script>
